import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Regions from './components/Regions';
import WhyUs from './components/WhyUs';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <Services />
      <Regions />
      <WhyUs />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}